// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-message[data-v-aa1ed110] {\n  font-size: 0.75rem;\n  margin-top: -12px;\n}\n.multiselect-econtador[data-v-aa1ed110] {\n  margin: 0;\n}\n#btn-incluir-dados[data-v-aa1ed110] {\n  margin-right: 5px;\n}\n@media screen and (max-width: 600px) {\n.btn-container[data-v-aa1ed110] {\n    margin-right: 0;\n}\n}\n@media screen and (min-width: 900px) {\n.btn-container[data-v-aa1ed110] {\n    width: 150px;\n    margin-right: auto;\n}\n}", ""]);
// Exports
module.exports = exports;
